module.exports = __webpack_public_path__ + "7e748b61200f564448711fbec4af34d7.svg";